<div class="form-group mb-0">
  <div class="input-group">
    <input
      type="text"
      class="form-control input-rounded"
      [formControl]="suggestion"
      [class.is-invalid]="failSearch"
      [ngbTypeahead]="search"
      (click)="clicks$.next($any($event).target.value)"
      #suggestionInput
      #instance="ngbTypeahead" />

    <div *ngIf="activeSearch" class="input-group-append-absolute">
      <div role="status" class="spinner-border text-light"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="input-group-append-absolute p-0 input-group-append-right">
      <ng-container *ngIf="!isFilled(); else filled">
        <button class="btn btn-outline-secondary" type="button" (click)="suggestionInput.click()">
          <i [ngClass]="['fa', 'fa-angle-down']"></i>
        </button>
      </ng-container>
      <ng-template #filled>
        <button class="btn btn-outline-secondary" type="button" (click)="reset(suggestionInput)">
          <i [ngClass]="['fa', 'fa-times']"></i>
        </button>
        <button class="btn btn-success" [ngStyle]="{'margin-left': '1px'}" type="button" (click)="saveSuggestion()">
          <i [ngClass]="['fa', 'fa-plus']"></i>
        </button>
      </ng-template>
    </div>
  </div>

  <ng-container *ngIf="suggestion.errors && (suggestion.dirty || suggestion.touched)">
    <div>
      <ng-container *ngFor="let errorType of getErrorKeys()">
        <div class="invalid-feedback force-show">
          {{ getErrorMessageByType(errorType) }}
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div class="invalid-feedback" *ngIf="failSearch">Sorry, suggestions could not be loaded.</div>

  <ng-container *ngIf="selection && selection.length > 0">
    <div class="saved-suggestion-container">
      <ul class="list-group-suggestion mt-1">
        <li class="clear-all">
          <span class="all fs-12" (click)="removeAllSuggestions()">&times;</span>
        </li>
        <li *ngFor="let selected of selection; let i = index">
          <span class="left fs-12" (click)="removeSuggestion(i)">&times;</span>
          <span>{{ selected }}</span>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
